import {
  Heading,
  NavigationLink,
  NavigationLinkText,
  VStack,
} from './NavigationSubHeaderWithLinks.style';

type Props = {
  header: string;
  links: {
    label: string;
    url: string;
    target?: string;
    altText?: string;
  }[];
};

export const NavigationSubHeaderWithLinks = ({ header, links }: Props) => {
  return (
    <VStack>
      <Heading>{header}</Heading>
      {links?.map(({ url, target, label }) => (
        <NavigationLink
          key={label}
          href={url}
          target={target || '_self'}
          aria-label={label}
        >
          <NavigationLinkText>{label}</NavigationLinkText>
        </NavigationLink>
      ))}
    </VStack>
  );
};
